var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.visible)?_c('v-btn',{attrs:{"icon":"","small":"","dark":"","rounded":""},on:{"click":function($event){return _vm.$router.go(-1)}}},[_c('v-icon',{attrs:{"dark":"","small":_vm.$vuetify.breakpoint.xs}},[_vm._v("arrow_back")])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }